import React from 'react';
import Card from '@mui/material/Card';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import { translate } from 'react-admin';

import CardIcon from './CardIcon';

const useStyles = makeStyles({
    main: {
        flex: '1',
        marginLeft: '1em',
        marginTop: 20,
    },
    card: {
        overflow: 'inherit',
        textAlign: 'right',
        padding: 16,
        minHeight: 52,
    },
});

const NbNewOrders = ({ value  }) => {
    const classes = useStyles();

    return  <div className={classes.main}>
                <CardIcon Icon={ShoppingCartIcon} bgColor="#ff9800" />
                <Card className={classes.card}>
                    <Typography className={classes.title} color="textSecondary">
                        New Orders
                    </Typography>
                    <Typography variant="headline" component="h2">
                        {value}
                    </Typography>
                </Card>
            </div>
};

// const enhance = compose(
//     withStyles(styles),
//     translate
// );

export default NbNewOrders;
